import { UTCFormatDate } from 'components/ui/transaction-history/components/transaction/utils'

import { matchType, matchStatus } from 'pages/account/wallets/info/components/tab-transactions'

import { saveAs } from 'file-saver'

export const filterAndTransformTransactions = (transactions) => {
  return transactions
    .filter((transaction) => transaction.status?.toLowerCase() && transaction.status?.toLowerCase() !== 'expired')
    .filter((transaction) => transaction.label === 'Exchanged')
    .map((tx) => {
      const type = matchType(tx.label, tx.account_type)
      const status = matchStatus(tx.status)
      return {
        ...tx,
        amountFrom: tx.amount_from_exchange,
        amountTo: tx.amount_to_exchange,
        from_currency: tx.from_currency,
        to_currency: tx.to_currency,
        amount: tx.amount,
        type: type,
        status: status,
      }
    })
}

export const exchangesSaveCSV = (transactions, fileNameCSV) => {
  const headerCSVRowsForExchange =
    [
      'Date',
      'Type',
      'Amount_from',
      'Currency_from',
      'Network_from',
      'Amount_to',
      'Currency_to',
      'Network_to',
      'TxID',
      'Status',
    ].join(',') + '\r\n'

  const rows = []

  transactions
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .forEach((data) => {
      const { date, type, amountTo, to_currency, amountFrom, from_currency, hash, status } = data

      const { code: toCode, network: toNetwork } = to_currency
      const { code: fromCode, network: fromNetwork } = from_currency

      const res =
        [UTCFormatDate(date), type, amountFrom, fromCode, fromNetwork, amountTo, toCode, toNetwork, hash, status].join(
          ',',
        ) + '\r\n'

      rows.push(res)
    })
  saveAs(new Blob([headerCSVRowsForExchange, ...rows], { type: 'text/csv;charset=utf-8' }), fileNameCSV)
}
